import {Component, HostListener, Input, OnInit} from '@angular/core';
import {MaintenanceModeConfig} from '../model/maintenance-config/maintenance-mode-config';
import {DateUtil} from '../shared/utils/Date/date-util';
import {TranslateService} from '@ngx-translate/core';
import {KeyDirections} from '../shared/key-directions.enum';
import {LanguageService} from '../services/language/language.service';

@Component({
  selector: 'app-maintenance-page',
  templateUrl: './maintenance-page.component.html',
  styleUrls: ['./maintenance-page.component.less']
})
export class MaintenancePageComponent implements OnInit {

  @Input()
  maintenanceModeConfig: MaintenanceModeConfig;
  inMaintenance: boolean;
  endDayName: string;
  endDayHour: string;
  endDayMinutes: string;


  constructor(private translateService: TranslateService, private languageService: LanguageService) {
  }

  ngOnInit() {
    this.inMaintenance = this.maintenanceModeConfig.isActive();
    this.endDayName = DateUtil.getNameOfDay(this.maintenanceModeConfig.endDate, this.languageService.getCurrentLanguage());
    this.endDayHour = this.maintenanceModeConfig.endDate.getHours() + '';
    this.endDayMinutes = this.maintenanceModeConfig.endDate.getMinutes() + '';
  }


  @HostListener('window:keydown', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.keyCode === KeyDirections.ESCAPE) {
      window.close();
    }
  }
}
